	// Trámites
import TramitesPlaSinArchivos from "@/views/reportes/TramitesPlaSinArchivos.vue";
import TramitesPlaObs from "@/views/reportes/TramitesPlaObs.vue";
import TramitesPlaDetObs from "@/views/reportes/TramitesPlaDetObs.vue";
import TramiteObservaciones from "@/views/reportes/TramiteObservaciones.vue";
import PlanillasObservaciones from "@/views/reportes/PlanillasObservaciones.vue";
import PlanillasMenuObservaciones from "@/views/reportes/PlanillasMenuObservaciones.vue";
import ReporteObservaciones01 from "@/views/reportes/ReporteObservaciones01.vue";
import ObservacionesTramite from "@/views/reportes/ObservacionesTramite.vue";
import ObsRespReportes from "@/views/reportes/ObsRespReportes.vue";
import ArchivoCarga from "@/views/reportes/ArchivoCarga.vue";
import ObservacionesReportes from "@/views/reportes/ObservacionesReportes.vue";
import TramiteNovedades from "@/views/reportes/TramiteNovedades.vue";
import ObservacionesFinanciador from "@/views/reportes/ObservacionesFinanciador.vue";
import ResumenObsResp from "@/views/reportes/ResumenObsResp.vue";
import ResumenJustificadas from "@/views/reportes/ResumenJustificadas.vue";
import ResumenTiempoObs from "@/views/reportes/ResumenTiempoObs.vue";
import ResumenTopObsEstandar from "@/views/reportes/ResumenTopObsEstandar.vue";
import UnificacionCodigos from "@/views/reportes/UnificacionCodigos.vue";
import CodigosNoMapeados from "@/views/reportes/CodigosNoMapeados.vue";
import FueraDePeriodo from "@/views/reportes/FueraDePeriodo.vue";
import PlanillaResumen from "@/views/reportes/PlanillaResumen.vue";
import PlanillasBorradas from "@/views/reportes/PlanillasBorradas.vue";
import PlanillaConsulta from "@/views/reportes/PlanillaConsulta.vue";
import Productividad from "@/views/reportes/Productividad.vue";

export default [
  {
    path: "/tramites-planillas-sin-archivos/:p_idtramite",
    name: "TramitesPlaSinArchivos",
    component: TramitesPlaSinArchivos,
  },
  {
    path: "/tramites-obs-pla/:p_idtramite",
    name: "TramitesPlaObs",
    component: TramitesPlaObs,
  },
  {
    path: "/tramites-obs-pla-det/:p_idtramite",
    name: "TramitesPlaDetObs",
    component: TramitesPlaDetObs,
  },
  {
    path: "/tramite-observaciones/:p_idtramite",
    name: "TramiteObservaciones",
    component: TramiteObservaciones,
  },
  {
    path: "/planillas-observaciones/:p_idtramite",
    name: "PlanillasObservaciones",
    component: PlanillasObservaciones,
  },
  {
    path: "/planillas-menu-observaciones/:p_idtramite",
    name: "PlanillasMenuObservaciones",
    component: PlanillasMenuObservaciones,
  },
  {
    path: "/observaciones-01/:idTramite/:observacionTipo",
    name: "ReporteObservaciones01",
    component: ReporteObservaciones01,
  },
  {
    path: "/observaciones-tramite/:p_idtramite",
    name: "ObservacionesTramite",
    component: ObservacionesTramite,
    props: true,
  },
  {
    path: "/obs-resp-tramite/:p_idtramite/:p_idservicio/:p_estadoTramite",
    name: "ObsRespReportes",
    component: ObsRespReportes,
    props: true,
  },
  {
    path: "/archivo-carga/:p_idtramite",
    name: "ArchivoCarga",
    component: ArchivoCarga,
    props: true,
  },
  {
    path: "/observaciones-reportes/:p_idtramite",
    name: "ObservacionesReportes",
    component: ObservacionesReportes,
    props: true,
  },
  {
    path: "/tramite-novedades/:p_idtramite",
    name: "TramiteNovedades",
    component: TramiteNovedades,
    props: true,
  },
  {
    path: "/observaciones-financiador/:p_idtramite/:p_idservicio/:p_estadoTramite",
    name: "ObservacionesFinanciador",
    component: ObservacionesFinanciador,
    props: true,
  },
  {
    path: "/resumen-obs-resp/:p_idtramite",
    name: "ResumenObsResp",
    component: ResumenObsResp,
    props: true,
  },
  {
    path: "/resumen-justificadas/:p_idtramite",
    name: "ResumenJustificadas",
    component: ResumenJustificadas,
    props: true,
  },
  {
    path: "/resumen-tiempo-obs/:p_idtramite",
    name: "ResumenTiempoObs",
    component: ResumenTiempoObs,
    props: true,
  },
  {
    path: "/resumen-top-obs-estandar/:p_idtramite",
    name: "ResumenTopObsEstandar",
    component: ResumenTopObsEstandar,
    props: true,
  },
  {
    path: "/unificacion-codigos/:p_idtramite",
    name: "UnificacionCodigos",
    component: UnificacionCodigos,
    props: true,
  },
  {
    path: "/codigos-no-mapeados/:p_idtramite",
    name: "CodigosNoMapeados",
    component: CodigosNoMapeados,
    props: true,
  },
  {
    path: "/fuera-de-periodo/:p_idtramite",
    name: "FueraDePeriodo",
    component: FueraDePeriodo,
    props: true,
  },
  {
    path: "/planilla-resumen/:p_idtramite",
    name: "PlanillaResumen",
    component: PlanillaResumen,
    props: true,
  },
  {
    path: "/planillas-borradas/:p_idtramite",
    name: "PlanillasBorradas",
    component: PlanillasBorradas,
    props: true,
  },
  {
    path: "/planilla-consulta/:idPlanilla",
    name: "PlanillaConsulta",
    component: PlanillaConsulta,
    props: true,
  },
  {
    path: "/productividad/:p_idtramite",
    name: "Productividad",
    component: Productividad,
    props: true,
  },
];
